import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop quest position reordering controller.
//
// Makes quest lists sortable via SortableJS. Supports reordering both
// top-level quests and sub-quests within their parent group.
//
// Usage:
//   <div data-controller="quest-sortable">
//     <div data-quest-sortable-target="list" data-parent-id="">
//       <div data-quest-sortable-target="item" data-move-url="/admin/quests/1/move">...</div>
//     </div>
//     <div data-quest-sortable-target="list" data-parent-id="5">
//       <div data-quest-sortable-target="item" data-move-url="/admin/quests/2/move">...</div>
//     </div>
//   </div>
//
export default class extends Controller {
  static targets = ["list", "item"]

  connect() {
    this.sortables = []
    this.listTargets.forEach((list) => {
      const sortable = Sortable.create(list, {
        handle: "[data-quest-sort-handle]",
        animation: 150,
        ghostClass: "quest-sort-ghost",
        chosenClass: "quest-sort-chosen",
        group: `quest-group-${list.dataset.parentId || "top"}`,
        onEnd: (evt) => this.onSortEnd(evt)
      })
      this.sortables.push(sortable)
    })
  }

  disconnect() {
    this.sortables.forEach((s) => s.destroy())
    this.sortables = []
  }

  async onSortEnd(evt) {
    const item = evt.item
    const newPosition = evt.newIndex + 1 // positions are 1-based
    const moveUrl = item.dataset.moveUrl

    if (!moveUrl || evt.oldIndex === evt.newIndex) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

    try {
      const response = await fetch(moveUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ position: newPosition })
      })

      if (!response.ok) {
        window.location.reload()
      }
    } catch (error) {
      console.error("Failed to reorder quest:", error)
      window.location.reload()
    }
  }
}
